
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetUrl } from "../config/GetUrl";

export const ChatApi = createApi({
    reducerPath: "ChatApi",
    baseQuery: fetchBaseQuery({
        baseUrl: GetUrl.API_URL,
    }),
    endpoints: (builder) => ({        
        GetChatUsers: builder.query({
            query: ({page=1, offset=20,search, categoryId}) => ({
                url: `/api/v1/Admin/getChatUsers?search=${search}&page=${page}&limit=${offset}`,
                method: "GET",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },
            }),
        }),
        GetMessages: builder.query({
            query: ({page=1, offset=20, chatId}) => ({
                url: `/api/v1/Admin/get-messages?chatId=${chatId}&page=${page}&limit=${offset}`,
                method: "GET",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },
            }),
        }),
        MarkAsRead: builder.mutation({
            query: ({messageIds}) => ({
                url: `/api/v1/Admin/mark-as-read`,
                method: "POST",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },
                body: {
                    messageIds,
                },
            }),
        }),

    }),
});

export const {
    useGetChatUsersQuery,
    useGetMessagesQuery,
    useMarkAsReadMutation,
   
} = ChatApi;
